import React from "react";
import PaymentProtection from "../../assets/svg/PaymentProtection";
import CouponIcon from "../../assets/svg/CouponIcon";
import ArrowRight from "../../assets/svg/ArrowRight";
import FlashIcon from "../../assets/svg/FlashIcon";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useLoader from "../../hooks/useLoader";
import useCoupon from "../../hooks/useCoupon";
import useCart from "../../hooks/useCart";
import useWallet from "../../hooks/useWallet";
import axiosPrivate from "../../axios/axiosPrivate";
import logo from "../../assets/icon/hayd_icon.avif";

const PayNetBanking = ({ regularPrice, comparePrice, walletApplied, onlinePayable, prepaidDiscount }) => {
  const { cartData } = useCart();
  const { useWalletCredit } = useWallet();
  const { couponData } = useCoupon();
  const { setLoading } = useLoader();
  const { user } = useAuth();
  const navigate = useNavigate();

  const payNetBanking = async () => {
    try {
      const couponApplied = couponData?.applied;
      const couponCode = couponData?.appliedCoupon?.coupon_name;
      const cart = [];

      cartData?.items?.map((data) => {
        const isUpsell = data?.properties?.upsell_discount === "true";
        const upsellPrice = data?.properties?.upsell_price;
        cart?.push({
          variant_id: data?.variant_id,
          quantity: data?.quantity,
          original_price: data?.price,
          ...(isUpsell && upsellPrice && { price: upsellPrice }),
        });
      });

      const payload = {
        cart,
        couponApplied,
        couponCode,
        payment_method: "online",
        osName: "WEB",
        useWallet: useWalletCredit,
      };

      setLoading(true);
      const response = await axiosPrivate.post("/orders/create-order", payload);

      // Wallet covered the whole order: no card payment needed.
      if (response?.data?.walletPaid) {
        setLoading(false);
        navigate("/thank-you", {
          state: { draftOrderId: response?.data?.draftOrderId },
          replace: true,
        });
        return;
      }
      const draftOrderId = response?.data?.draftOrderId;

      const options = {
        description: "HAYD Brands",
        image: logo,
        currency: "INR",
        key: response?.data?.key,
        amount: response?.data?.amount,
        name: "HAYD Brands",
        order_id: response?.data?.razorpayOrderId,
        method: {
          upi: false,
          card: false,
          netbanking: true,
          wallet: false,
          emi: false,
          paylater: false,
        },
        prefill: {
          email: user?.email ? user?.email : "",
          contact: user?.phone,
          name:
            user?.first_name === "HAYD_USER"
              ? "User"
              : user?.first_name + " " + user?.last_name,
        },
        theme: { color: "#000000" },
        handler: function (paymentResponse) {
          setLoading(false);
          navigate("/thank-you", {
            state: { draftOrderId, value: response?.data?.amount },
            replace: true,
          });
        },
        modal: {
          ondismiss: function () {
            setLoading(false);
            console.log("inside dismiss where all order get delete");
            // DELETE DRAFT ORDER WHICH IS CREATED
            if (draftOrderId) {
              try {
                const deleteDraftorder = axiosPrivate.delete(
                  `/orders/delete-draft-order`,
                  {
                    data: { draftOrderId },
                  }
                );
              } catch (error) {
                console.log("hello");
              }
            }
            console.log("Payment popup closed");
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        setLoading(false);
        console.log("Payment failed:");
      });

      rzp.open();
    } catch (error) {
      console.log(error?.response?.data || error?.message);
      setLoading(false);
    }
  };

  return (
    <div
      className="py-4 flex justify-between items-start gap-2 cursor-pointer hover:bg-gray-50"
      onClick={payNetBanking}
    >
      <div className="flex items-start gap-2">
        <div className="border border-1 px-[3px] py-[2px]  border-gray-400 rounded-[4px]">
          <PaymentProtection width={18} height={18} />
        </div>
        <div>
          <div className="flex items-center gap-[2px] break-words flex-wrap">
            <p className="text-[16px] supreme-medium">Net Banking</p>
            <FlashIcon width={14} height={14} className="text-blue-500" />
          </div>
          {prepaidDiscount > 0 && <div className="mt-2 flex items-center gap-1">
            <CouponIcon width={14} height={14} className="fill-green-700" />
            <p className="text-[14px] general-sans-regular text-green-700">
              Save ₹{prepaidDiscount}
            </p>
          </div>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-baseline gap-2 break-words flex-wrap">
          <p className="text-[14px] supreme-medium line-through text-gray-500">
            ₹
            {couponData?.appliedCoupon?.discountAmount
              ? regularPrice
              : comparePrice}
          </p>
          <p className="text-[16px] supreme-bold">
            ₹
            {Math.max(
              0,
              Number(onlinePayable) - (walletApplied || 0)
            ).toFixed(2)}
          </p>
        </div>
        <ArrowRight width={14} height={14} className="fill-gray-500" />
      </div>
    </div>
  );
};

export default PayNetBanking;
